import { ComponentConfig } from "@measured/puck"
import { PostGridProps, RenderConfig } from "./RenderConfig"

export const PostGrid: ComponentConfig<PostGridProps> = {
  label: "Post Grid",
  fields: {
    title: {
      type: "text",
      label: "Title",
    },
    subTitle: {
      type: "text",
      label: "Sub Title",
    },
    pageSize: {
      type: "text",
      label: "Page Size",
    },
    loadMoreUrl: {
      type: "text",
      label: "Load More Url",
    },
    className: {
      type: "text",
      label: "Class Name",
    },
  },
  defaultProps: {
    title: "Bài viết mới nhất",
    subTitle: "Bài viết mới nhất",
    pageSize: "8",
    loadMoreUrl: "",
    className: "",
  },
  ...RenderConfig,
}
